/* Case Studio -- layered case designer for EXILE.
   Layers: photo (with filters), text (font/colour/size/curve/bold/italic),
   sticker and emoji. Everything is drawn into one canvas, clipped to the
   print box and masked to the case shape; the same routine produces the
   print-ready file on add to cart. */
(function(){
"use strict";
if (!document.getElementById("case-studio")) return;

var CFG = JSON.parse(document.getElementById("case-studio-config").textContent);
var W = CFG.W, H = CFG.H;
var CASES = CFG.cases;
var FONTS = CFG.fonts || [];
var STICKERS = CFG.stickers || [];

/* Phone models. Same price for all; mockup + print template are the 17 Pro Max.
   A product with no variants to pick (the power bank) passes "models": []. */
var DEFAULT_MODELS = [
  "iPhone 17 Pro Max","iPhone 18 Pro Max","iPhone 18 Pro","iPhone 17 Pro","iPhone 17 Air","iPhone 17",
  "iPhone 16 Pro Max","iPhone 16 Pro","iPhone 16 Plus","iPhone 16",
  "iPhone 15 Pro Max","iPhone 15 Pro","iPhone 15 Plus","iPhone 15",
  "iPhone 14 Pro Max","iPhone 14 Pro","iPhone 14 Plus","iPhone 14",
  "iPhone 13 Pro Max","iPhone 13 Pro","iPhone 13"
];
var MODELS = CFG.models ? CFG.models : DEFAULT_MODELS;
var HAS_MODELS = MODELS.length > 0;
var MODEL_LABEL = CFG.modelLabel || "Phone model";
var MAGSAFE_ONLY = CFG.models ? [] : ["iphone 13 pro","iphone 18 pro max","iphone 18 pro"];
var PREVIEW_MODEL = CFG.models ? (MODELS[0] || "") : "iPhone 17 Pro Max";
/* What the thing is called in the hints: "case", "power bank", ... */
var NOUN = CFG.noun || "case";
var TITLE = CFG.title || "";
/* Made-to-order lead time. Set, it rides along on the cart line so the
   builder's products say the same thing as the rest of the store. */
var PREORDER = CFG.preorder || "";

var FILTERS = [
  { id:"original", name:"Original", css:"none" },
  { id:"bw",       name:"B&W",      css:"grayscale(1) contrast(1.05)" },
  { id:"warm",     name:"Warm",     css:"sepia(.35) saturate(1.3) hue-rotate(-8deg)" },
  { id:"cool",     name:"Cool",     css:"saturate(1.1) hue-rotate(14deg) brightness(1.03)" },
  { id:"fade",     name:"Fade",     css:"contrast(.85) saturate(.7) brightness(1.09)" },
  { id:"punch",    name:"Punch",    css:"contrast(1.28) saturate(1.5)" }
];
var TEXT_BASE = 100;   /* text is measured at this size; layer.scale does the rest */

/* Base colour printed behind everything, clipped to the product shape the same
   way the artwork is. "" leaves the product the colour it was photographed. */
var BG_COLORS = CFG.bgColors || [
  "#FFFFFF","#111111","#F2EDE3","#F5C842","#F08A3C","#E85D4E","#E8447F","#C44FC4",
  "#7B4FE0","#2F5FE0","#3FA0F0","#2BB3AE","#2FB673","#4CC05A","#8FBF3F","#EFE6A8"
];

/* Collage layouts. Cells are fractions of the print box, so one definition
   works on every case shape and survives a switch between them. */
var LAYOUTS = [
  { id:"2v",  name:"2 stacked",   cells:[[0,0,1,.5],[0,.5,1,.5]] },
  { id:"2h",  name:"2 across",    cells:[[0,0,.5,1],[.5,0,.5,1]] },
  { id:"3v",  name:"3 stacked",   cells:[[0,0,1,1/3],[0,1/3,1,1/3],[0,2/3,1,1/3]] },
  { id:"1+2", name:"1 big + 2",   cells:[[0,0,1,.56],[0,.56,.5,.44],[.5,.56,.5,.44]] },
  { id:"2+1", name:"2 + 1 big",   cells:[[0,0,.5,.44],[.5,0,.5,.44],[0,.44,1,.56]] },
  { id:"4",   name:"4 grid",      cells:[[0,0,.5,.5],[.5,0,.5,.5],[0,.5,.5,.5],[.5,.5,.5,.5]] },
  { id:"L",   name:"1 tall + 2",  cells:[[0,0,.5,1],[.5,0,.5,.5],[.5,.5,.5,.5]] },
  { id:"6",   name:"6 grid",      cells:[[0,0,.5,1/3],[.5,0,.5,1/3],[0,1/3,.5,1/3],[.5,1/3,.5,1/3],[0,2/3,.5,1/3],[.5,2/3,.5,1/3]] },
  { id:"9",   name:"9 grid",      cells:[[0,0,1/3,1/3],[1/3,0,1/3,1/3],[2/3,0,1/3,1/3],
                                          [0,1/3,1/3,1/3],[1/3,1/3,1/3,1/3],[2/3,1/3,1/3,1/3],
                                          [0,2/3,1/3,1/3],[1/3,2/3,1/3,1/3],[2/3,2/3,1/3,1/3]] }
];
function layoutById(id){ for (var i=0;i<LAYOUTS.length;i++) if (LAYOUTS[i].id === id) return LAYOUTS[i]; return null; }

var S = { caseId:(CASES[0] && CASES[0].id) || "silver", model:MODELS[0] || "", bg:"", layout:"", layers:[], sel:0 };if (magsafeOnly()) S.caseId = allowedCases()[0].id;
var pendingSlot = 0;   /* slot waiting for the file picker to come back */
var seq = 0;
var EDIT = null, EDIT_KEY = "";
try { EDIT_KEY = new URLSearchParams(location.search).get("edit") || ""; } catch(e){ EDIT_KEY = ""; }
var CHANGE_URL = (CFG.routes.cartAdd || "/cart/add.js").replace(/\/add(\.js)?$/i, "/change.js");

var view = { fit:1, zoom:1, px:0, py:0 };
var ZOOM_MIN = 1, ZOOM_MAX = 4;
/* An honest device-pixel canvas at four times zoom runs to tens of megabytes.
   A phone kills the tab long before that extra detail helps, so the backing
   store is held inside a budget and the browser stretches the rest. */
var PIXEL_BUDGET = (window.matchMedia && window.matchMedia("(pointer:coarse)").matches) ? 4.5e6 : 12e6;
/* An upload is decoded once at a working size. The untouched file is still
   what goes to print, so nothing is lost here but the memory. */
var WORK_MAX = 2600;
var imgCache = new Map();
var ready = false;
var tab = "photos";

var ROOT = document.getElementById("case-studio");
var $ = function(s){ return ROOT.querySelector(s); };
var $$ = function(s){ return ROOT.querySelectorAll(s); };
var el = function(t,a,h){ var n=document.createElement(t); if(a) for(var k in a) n.setAttribute(k,a[k]); if(h!=null) n.innerHTML=h; return n; };
var clamp = function(v,a,b){ return Math.min(b,Math.max(a,v)); };
var _fmt = (function(){ try { return new Intl.NumberFormat(undefined,{style:"currency",currency:CFG.currencyCode}); } catch(e){ return null; } })();
var money = function(n){ return _fmt ? _fmt.format(n) : (CFG.currencyCode + " " + n.toFixed(2)); };
var esc = function(s){ return String(s).replace(/[&<>"']/g, function(c){ return {"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}[c]; }); };

function CC(){ for (var i=0;i<CASES.length;i++) if (CASES[i].id === S.caseId) return CASES[i]; return CASES[0]; }
function BOX(){ return CC().box; }

/* ---------- perspective ----------
   A case photographed straight on needs nothing: the print box is an
   axis-aligned rectangle and the artwork is drawn into it as-is. A product
   shot at an angle (the power bank) carries a "quad": the four corners of its
   printable face, clockwise from top-left, in mockup pixels. The artwork is
   still drawn and printed flat -- only the on-screen preview is mapped onto
   that quad, so what the customer sees sits on the product properly. */
function QUAD(){ return CC().quad || null; }
function boxPts(b){ return [[b.x,b.y],[b.x+b.w,b.y],[b.x+b.w,b.y+b.h],[b.x,b.y+b.h]]; }

/* The 3x3 homography taking the four src points to the four dst points,
   returned as [a,b,c,d,e,f,g,h] with the ninth term fixed at 1. */
function solveH(src, dst){
  var A = [], B = [], i;
  for (i=0;i<4;i++){
    var sx = src[i][0], sy = src[i][1], dx = dst[i][0], dy = dst[i][1];
    A.push([sx,sy,1,0,0,0,-dx*sx,-dx*sy]); B.push(dx);
    A.push([0,0,0,sx,sy,1,-dy*sx,-dy*sy]); B.push(dy);
  }
  /* Gaussian elimination with partial pivoting -- only 8x8, once per layout. */
  var n = 8, r, c, k;
  for (c=0;c<n;c++){
    var piv = c;
    for (r=c+1;r<n;r++) if (Math.abs(A[r][c]) > Math.abs(A[piv][c])) piv = r;
    var tA = A[c]; A[c] = A[piv]; A[piv] = tA;
    var tB = B[c]; B[c] = B[piv]; B[piv] = tB;
    if (!A[c][c]) return null;
    for (r=c+1;r<n;r++){
      var f = A[r][c] / A[c][c];
      if (!f) continue;
      for (k=c;k<n;k++) A[r][k] -= f*A[c][k];
      B[r] -= f*B[c];
    }
  }
  var x = new Array(n);
  for (r=n-1;r>=0;r--){
    var s = B[r];
    for (c=r+1;c<n;c++) s -= A[r][c]*x[c];
    x[r] = s / A[r][r];
  }
  return x;
}
function applyH(h, x, y){
  var d = h[6]*x + h[7]*y + 1;
  return [ (h[0]*x + h[1]*y + h[2]) / d, (h[3]*x + h[4]*y + h[5]) / d ];
}
/* CSS wants a column-major 4x4; the z row is identity and w picks up g/h. */
function cssMatrix(h){
  return "matrix3d(" +
    [ h[0], h[3], 0, h[6],
      h[1], h[4], 0, h[7],
      0,    0,    1, 0,
      h[2], h[5], 0, 1 ].join(",") + ")";
}
function sel(){ for (var i=0;i<S.layers.length;i++) if (S.layers[i].id === S.sel) return S.layers[i]; return null; }
function idxOf(id){ for (var i=0;i<S.layers.length;i++) if (S.layers[i].id === id) return i; return -1; }

var artCanvas = $("#art");
var actx = artCanvas.getContext("2d");
var CAN_FILTER = (function(){ try { return typeof actx.filter === "string"; } catch(e){ return false; } })();

/* ---------- images ---------- */
function newImg(src){ var im = new Image(); if (/^https?:/i.test(src)) im.crossOrigin = "anonymous"; return im; }
function getImage(src){
  if (imgCache.has(src)) return imgCache.get(src);
  var im = newImg(src); im.onload = function(){ render(); }; im.src = src;
  imgCache.set(src, im); return im;
}
function loadImage(src){
  return new Promise(function(res, rej){
    if (imgCache.has(src)){
      var c = imgCache.get(src);
      if (c.complete) return c.naturalWidth ? res(c) : rej(new Error("bad image"));
    }
    var im = newImg(src);
    im.onload = function(){ imgCache.set(src, im); res(im); };
    im.onerror = function(){ rej(new Error("bad image")); };
    im.src = src;
  });
}
function preload(){
  var srcs = [];
  CASES.forEach(function(c){ srcs.push(c.img, c.mask); });
  return Promise.all(srcs.map(function(src){ return new Promise(function(res){
    var im = newImg(src);
    im.onload = im.onerror = function(){ imgCache.set(src, im); res(); };
    im.src = src;
  }); }));
}

/* Sticker SVGs are turned into a same-origin blob so the canvas is never
   tainted; the original URL stays on the layer so a design can be rebuilt. */
function loadArt(url){
  if (!/\.svg(\?|$)/i.test(url)) return loadImage(url);
  return fetch(url)
    .then(function(r){ if (!r.ok) throw new Error("no art"); return r.text(); })
    .then(function(svg){
      if (!/<svg[^>]*\swidth=/i.test(svg)) svg = svg.replace(/<svg/i, '<svg width="512" height="512"');
      return loadImage(URL.createObjectURL(new Blob([svg], { type:"image/svg+xml" })));
    });
}
/* Emoji are drawn with the viewer's own system emoji font, so Apple devices
   get Apple's artwork. Nothing is downloaded and nothing is redistributed. */
var EMOJI_FONT = '"Apple Color Emoji","Segoe UI Emoji","Noto Color Emoji",sans-serif';
function emojiChar(code){
  var parts = String(code).split("-");
  var s = parts.map(function(h){ return String.fromCodePoint(parseInt(h,16)); }).join("");
  /* The variation selector is written as an escape so the file stays plain
     ASCII -- an invisible character does not survive every editor. */
  if (parts.length === 1) s += "️";
  return s;
}
function measureEmoji(L){
  actx.save();
  actx.font = TEXT_BASE + "px " + EMOJI_FONT;
  L.w = Math.max(10, actx.measureText(L.ch).width);
  actx.restore();
  L.h = Math.max(10, TEXT_BASE * 1.18);
}
function addEmoji(ch){
  var b = BOX();
  var L = { id:++seq, type:"emoji", ch:ch, name:ch, w:0, h:0,
            x:b.w/2, y:b.h/2, rot:0, scale:1 };
  measureEmoji(L);
  L.scale = (b.w * 0.34) / Math.max(1, L.w);
  S.layers.push(L); S.sel = L.id;
  return L;
}

/* ---------- layers ---------- */
function addPhoto(src, natW, natH, name, file){
  var b = BOX(), cover = Math.max(b.w/natW, b.h/natH);
  var L = { id:++seq, type:"photo", src:src, url:"", file:file||null, name:name||"Photo",
            natW:natW, natH:natH, w:natW, h:natH, filter:"original",
            x:b.w/2, y:b.h/2, rot:0, scale:cover };
  S.layers.push(L); S.sel = L.id;
  return L;
}
function addArt(img, ref, label){
  var b = BOX();
  var nw = img.naturalWidth || 512, nh = img.naturalHeight || 512;
  var L = { id:++seq, type:"sticker", src:img.src, ref:ref, name:label || "Sticker",
            natW:nw, natH:nh, w:nw, h:nh,
            x:b.w/2, y:b.h/2, rot:0, scale:(b.w * 0.34)/nw };
  S.layers.push(L); S.sel = L.id;
  return L;
}
/* White type on a bare case is invisible -- on screen, and more expensively on
   the printed film, where a white-on-transparent file looks like nothing was
   ordered at all. The first colour follows whatever the case is wearing; the
   picker is right there if they want something else. */
function defaultInk(){
  var h = String(S.bg || "").replace("#","");
  if (h.length !== 6) return "#111111";
  var r = parseInt(h.slice(0,2),16), g = parseInt(h.slice(2,4),16), b = parseInt(h.slice(4,6),16);
  return (0.299*r + 0.587*g + 0.114*b) > 150 ? "#111111" : "#FFFFFF";
}
function addText(){
  var b = BOX();
  var L = { id:++seq, type:"text", text:"Your text",
            font:(FONTS[0] && FONTS[0].css) || "Archivo, sans-serif",
            color:defaultInk(), bold:true, italic:false, curve:0,
            w:0, h:0, x:b.w/2, y:b.h/2, rot:0, scale:1 };
  measureText(L);
  L.scale = (b.w * 0.72) / Math.max(1, L.w);
  S.layers.push(L); S.sel = L.id;
  return L;
}
function removeLayer(id){
  var i = idxOf(id);
  if (i < 0) return;
  S.layers.splice(i, 1);
  S.sel = S.layers.length ? S.layers[Math.min(i, S.layers.length-1)].id : 0;
}
function duplicateLayer(id){
  var i = idxOf(id);
  if (i < 0) return;
  var c = {}, src = S.layers[i];
  for (var k in src) c[k] = src[k];
  c.id = ++seq; c.x += 18; c.y += 18;
  S.layers.splice(i+1, 0, c);
  S.sel = c.id;
}
function moveLayer(id, dir){
  var i = idxOf(id), j = i + dir;
  if (i < 0 || j < 0 || j >= S.layers.length) return;
  var t = S.layers[i]; S.layers[i] = S.layers[j]; S.layers[j] = t;
}

function fontSpec(L, size){
  return (L.italic ? "italic " : "") + (L.bold ? "700 " : "400 ") + size + "px " + L.font;
}
function measureText(L){
  actx.save();
  actx.font = fontSpec(L, TEXT_BASE);
  var lines = String(L.text || " ").split("\n");
  var wmax = 0;
  for (var i=0;i<lines.length;i++) wmax = Math.max(wmax, actx.measureText(lines[i]).width);
  actx.restore();
  L.w = Math.max(10, wmax);
  L.h = Math.max(10, lines.length * TEXT_BASE * 1.22);
  if (L.curve){
    var theta = Math.abs(L.curve/100) * Math.PI * 0.9;
    var R = L.w / theta;
    L.h += R * (1 - Math.cos(theta/2));
  }
}
function layerBox(L){ return { w: L.w * L.scale, h: L.h * L.scale }; }

/* ---------- collage slots ---------- */
function cellRect(L){
  var b = BOX(), c = L.cell;
  return { x:c[0]*b.w, y:c[1]*b.h, w:c[2]*b.w, h:c[3]*b.h };
}
/* Empty cells are drawn light on a dark product and dark on a light one. */
function bgIsLight(){
  var h = String(S.bg || "").replace("#","");
  if (h.length !== 6) return false;               /* bare product: assume dark */
  var r = parseInt(h.slice(0,2),16), g = parseInt(h.slice(2,4),16), bl = parseInt(h.slice(4,6),16);
  return (0.299*r + 0.587*g + 0.114*bl) > 150;
}
function applyLayout(id){
  S.layers = S.layers.filter(function(L){ return L.type !== "slot"; });
  var lay = layoutById(id);
  S.layout = lay ? id : "";
  if (!lay){ S.sel = 0; return; }
  var made = lay.cells.map(function(c){
    return { id:++seq, type:"slot", cell:c.slice(), src:"", ref:"", url:"", file:null, name:"",
             natW:0, natH:0, filter:"original", zoom:1, ox:0, oy:0 };
  });
  /* Slots sit under everything so text and stickers stay on top. */
  S.layers = made.concat(S.layers);
  S.sel = 0;
}
function fillSlot(L, src, natW, natH, name, file){
  L.src = src; L.natW = natW; L.natH = natH; L.name = name || "";
  L.file = file || null; L.url = ""; L.ref = "";
  L.zoom = 1; L.ox = 0; L.oy = 0;
}
function clearSlot(L){
  L.src = ""; L.natW = 0; L.natH = 0; L.name = ""; L.file = null; L.url = ""; L.ref = "";
  L.zoom = 1; L.ox = 0; L.oy = 0;
}
/* How far the photo may slide before it would leave a gap in its cell. */
function panLimit(L){
  var r = cellRect(L);
  if (!L.natW || !L.natH) return { x:0, y:0 };
  var cover = Math.max(r.w/L.natW, r.h/L.natH) * L.zoom;
  return { x: Math.max(0, (L.natW*cover - r.w)/2) / r.w,
           y: Math.max(0, (L.natH*cover - r.h)/2) / r.h };
}
function clampPan(L){
  var lim = panLimit(L);
  L.ox = clamp(L.ox, -lim.x, lim.x);
  L.oy = clamp(L.oy, -lim.y, lim.y);
}
function drawSlot(ctx, L, forPrint){
  var r = cellRect(L);
  ctx.save();
  ctx.beginPath(); ctx.rect(r.x, r.y, r.w, r.h); ctx.clip();
  var im = L.src ? getImage(L.src) : null;
  if (im && im.complete && im.naturalWidth){
    var cover = Math.max(r.w/L.natW, r.h/L.natH) * L.zoom;
    var dw = L.natW*cover, dh = L.natH*cover;
    var dx = r.x + (r.w-dw)/2 + L.ox*r.w;
    var dy = r.y + (r.h-dh)/2 + L.oy*r.h;
    if (CAN_FILTER){
      var f = null;
      for (var i=0;i<FILTERS.length;i++) if (FILTERS[i].id === L.filter) f = FILTERS[i];
      ctx.filter = (f && f.css) || "none";
    }
    ctx.drawImage(im, dx, dy, dw, dh);
    if (CAN_FILTER) ctx.filter = "none";
  } else if (!forPrint){
    /* An empty cell is a prompt, not artwork: never goes near the print file. */
    var light = !bgIsLight();
    var ink = light ? "rgba(255,255,255,.62)" : "rgba(20,24,32,.46)";
    ctx.fillStyle = light ? "rgba(255,255,255,.07)" : "rgba(20,24,32,.05)";
    ctx.fillRect(r.x, r.y, r.w, r.h);
    var pad = Math.max(3, Math.min(r.w, r.h) * 0.035);
    ctx.strokeStyle = ink;
    ctx.lineWidth = Math.max(2, Math.min(r.w, r.h) * 0.012);
    ctx.setLineDash([Math.max(8, r.w*0.05), Math.max(6, r.w*0.035)]);
    ctx.strokeRect(r.x+pad, r.y+pad, r.w-pad*2, r.h-pad*2);
    ctx.setLineDash([]);
    var a = Math.min(r.w, r.h) * 0.17, cx = r.x + r.w/2, cy = r.y + r.h/2;
    ctx.lineWidth = Math.max(3, a*0.16);
    ctx.lineCap = "round";
    ctx.beginPath();
    ctx.moveTo(cx-a/2, cy); ctx.lineTo(cx+a/2, cy);
    ctx.moveTo(cx, cy-a/2); ctx.lineTo(cx, cy+a/2);
    ctx.stroke();
  }
  ctx.restore();
}

/* ---------- painting ---------- */
function drawText(ctx, L){
  ctx.font = fontSpec(L, TEXT_BASE);
  ctx.fillStyle = L.color;
  ctx.textAlign = "center";
  ctx.textBaseline = "middle";
  var lines = String(L.text || "").split("\n");

  if (!L.curve || lines.length > 1){
    var lh = TEXT_BASE * 1.22;
    var top = -((lines.length - 1) * lh) / 2;
    for (var i=0;i<lines.length;i++) ctx.fillText(lines[i], 0, top + i*lh);
    return;
  }

  var chars = String(lines[0]).split("");
  var widths = [], total = 0, j;
  for (j=0;j<chars.length;j++){ widths[j] = ctx.measureText(chars[j]).width; total += widths[j]; }
  if (!total) return;
  var theta = Math.abs(L.curve/100) * Math.PI * 0.9;
  var R = total / theta;
  var up = L.curve > 0;
  var ang = -theta/2;

  ctx.save();
  ctx.translate(0, up ? R : -R);
  for (j=0;j<chars.length;j++){
    var a = ang + (widths[j]/2) / R;
    ctx.save();
    ctx.rotate(up ? a : -a);
    ctx.translate(0, up ? -R : R);
    ctx.fillText(chars[j], 0, 0);
    ctx.restore();
    ang += widths[j] / R;
  }
  ctx.restore();
}

function drawLayer(ctx, L, forPrint){
  if (L.type === "slot"){ drawSlot(ctx, L, forPrint); return; }
  ctx.save();
  ctx.translate(L.x, L.y);
  ctx.rotate(L.rot * Math.PI/180);
  if (L.type === "text"){
    ctx.scale(L.scale, L.scale);
    drawText(ctx, L);
  } else if (L.type === "emoji"){
    ctx.scale(L.scale, L.scale);
    ctx.font = TEXT_BASE + "px " + EMOJI_FONT;
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.fillText(L.ch, 0, 0);
  } else {
    var im = getImage(L.src);
    if (im.complete && im.naturalWidth){
      if (CAN_FILTER && L.type === "photo"){
        var f = null;
        for (var i=0;i<FILTERS.length;i++) if (FILTERS[i].id === L.filter) f = FILTERS[i];
        ctx.filter = (f && f.css) || "none";
      }
      var w = L.w * L.scale, h = L.h * L.scale;
      ctx.drawImage(im, -w/2, -h/2, w, h);
      if (CAN_FILTER) ctx.filter = "none";
    }
  }
  ctx.restore();
}

function paintArt(ctx, scale){
  var C = CC(), b = C.box;
  ctx.setTransform(1,0,0,1,0,0);
  ctx.clearRect(0,0,W*scale,H*scale);
  ctx.save();
  ctx.scale(scale,scale);
  ctx.translate(b.x,b.y);
  ctx.beginPath(); ctx.rect(0,0,b.w,b.h); ctx.clip();
  if (S.bg){ ctx.fillStyle = S.bg; ctx.fillRect(0,0,b.w,b.h); }
  for (var i=0;i<S.layers.length;i++) drawLayer(ctx, S.layers[i], false);
  ctx.restore();
  var mk = imgCache.get(C.mask);
  if (mk && mk.complete && mk.naturalWidth){
    ctx.globalCompositeOperation = "destination-in";
    ctx.drawImage(mk, 0, 0, W*scale, H*scale);
    ctx.globalCompositeOperation = "source-over";
  }
}

/* ---------- selection overlay ---------- */
function buildOverlay(){
  var b = BOX(), k = viewK();
  var svg = $("#overlay");
  svg.setAttribute("viewBox", "0 0 " + b.w + " " + b.h);
  svg.style.left = b.x + "px"; svg.style.top = b.y + "px";
  svg.style.width = b.w + "px"; svg.style.height = b.h + "px";
  var p = sel();
  if (!p){ svg.innerHTML = ""; return; }
  if (p.type === "slot"){
    var cr = cellRect(p), csw = 2.2/k;
    svg.innerHTML =
      '<rect x="' + cr.x + '" y="' + cr.y + '" width="' + cr.w + '" height="' + cr.h + '" ' +
        'fill="none" stroke="#00A6D6" stroke-width="' + csw + '"/>';
    return;
  }
  var bb = layerBox(p), hr = 9/k, sw = 1.6/k;
  var c = [[-bb.w/2,-bb.h/2],[bb.w/2,-bb.h/2],[bb.w/2,bb.h/2],[-bb.w/2,bb.h/2]];
  var rotY = -bb.h/2 - 34/k;
  var delX = -bb.w/2 - 22/k, delY = -bb.h/2 - 22/k, dr = 11/k;
  svg.innerHTML =
    '<g transform="translate(' + p.x + ' ' + p.y + ') rotate(' + p.rot + ')">' +
      '<polygon points="' + c.map(function(q){return q.join(",");}).join(" ") + '" fill="none" stroke="#00A6D6" stroke-width="' + sw + '"/>' +
      '<line x1="0" y1="' + (-bb.h/2) + '" x2="0" y2="' + (rotY+hr) + '" stroke="#00A6D6" stroke-width="' + sw + '"/>' +
      '<circle cx="0" cy="' + rotY + '" r="' + hr + '" fill="#00A6D6" stroke="#fff" stroke-width="' + sw + '" style="pointer-events:auto;cursor:grab" data-handle="rot"/>' +
      c.map(function(q,i){ return '<rect x="' + (q[0]-hr) + '" y="' + (q[1]-hr) + '" width="' + (hr*2) + '" height="' + (hr*2) + '" rx="' + (hr*0.35) + '" fill="#fff" stroke="#00A6D6" stroke-width="' + sw + '" style="pointer-events:auto;cursor:nwse-resize" data-handle="s' + i + '"/>'; }).join("") +
      '<g style="pointer-events:auto;cursor:pointer" data-handle="del">' +
        '<circle cx="' + delX + '" cy="' + delY + '" r="' + dr + '" fill="#E5484D" stroke="#fff" stroke-width="' + sw + '"/>' +
        '<path d="M' + (delX-dr*0.4) + ' ' + (delY-dr*0.4) + 'L' + (delX+dr*0.4) + ' ' + (delY+dr*0.4) +
             'M' + (delX+dr*0.4) + ' ' + (delY-dr*0.4) + 'L' + (delX-dr*0.4) + ' ' + (delY+dr*0.4) +
             '" stroke="#fff" stroke-width="' + (sw*1.5) + '" stroke-linecap="round"/>' +
      '</g>' +
    '</g>';
}

function viewK(){ return view.fit * view.zoom; }

/* Everything the stage needs on a zoom step except the canvas itself. Kept
   apart from layout() so a pinch can run at screen speed: reallocating the
   backing store every frame would clear and repaint it sixty times a second. */
function sizeStage(){
  var k = viewK();
  var device = $("#device"), inner = $("#deviceInner");
  device.style.width = (W*k) + "px"; device.style.height = (H*k) + "px";
  inner.style.width = W + "px"; inner.style.height = H + "px";
  inner.style.transform = "scale(" + k + ")";
  applyView();
  applyPerspective();
  placeUploader();
}

/* The case may be dragged around once it is bigger than the stage, but never
   so far that it leaves the window. */
function clampView(){
  var st = $("#stage");
  if (!st){ return; }
  var k = viewK();
  var mx = Math.max(0, (W*k - st.clientWidth)/2 + 24);
  var my = Math.max(0, (H*k - st.clientHeight)/2 + 24);
  view.px = clamp(view.px, -mx, mx);
  view.py = clamp(view.py, -my, my);
}

function applyView(){
  clampView();
  /* Only the pan lives here. Holding the case in the middle of the stage at
     any size is the stylesheet's job -- see .stage / .device in
     case-studio-pro.css. */
  var d = $("#device");
  if (d) d.style.transform = (view.px || view.py) ? "translate(" + view.px + "px," + view.py + "px)" : "";
  var pct = $("#zoomPct");
  if (pct) pct.textContent = Math.round(view.zoom*100) + "%";
  var zi = $("#zoomIn"), zo = $("#zoomOutBtn");
  if (zi) zi.disabled = view.zoom >= ZOOM_MAX - 1e-4;
  if (zo) zo.disabled = view.zoom <= ZOOM_MIN + 1e-4;
  var wr = $("#stageWrap");
  if (wr) wr.classList.toggle("cs-zoomed", view.zoom > ZOOM_MIN + 1e-4);
}

/* Zoom about a point on screen, so whatever is under the fingers -- or under
   the middle of the stage, for the buttons -- stays where it is. */
function setZoom(z, cx, cy, fast){
  z = clamp(z, ZOOM_MIN, ZOOM_MAX);
  if (Math.abs(z - view.zoom) < 1e-4) return;
  var st = $("#stage");
  if (st && cx != null){
    var r = st.getBoundingClientRect();
    var ox = cx - r.left - r.width/2 - view.px;
    var oy = cy - r.top - r.height/2 - view.py;
    var f = z / view.zoom;
    view.px -= ox * (f - 1);
    view.py -= oy * (f - 1);
  }
  view.zoom = z;
  if (z <= ZOOM_MIN + 1e-4){ view.px = 0; view.py = 0; }
  if (fast){ sizeStage(); return; }
  layout(); render();
}
function stepZoom(dir){
  var st = $("#stage"), r = st ? st.getBoundingClientRect() : null;
  setZoom(view.zoom * (dir > 0 ? 1.3 : 1/1.3),
          r ? r.left + r.width/2 : null, r ? r.top + r.height/2 : null);
}
function resetZoom(){ view.px = 0; view.py = 0; view.zoom = ZOOM_MIN; layout(); render(); }

function layout(){
  var wrap = $("#stageWrap");
  var availW = wrap.clientWidth - 70, availH = wrap.clientHeight - 44;
  view.fit = Math.min(availW/W, availH/H);
  sizeStage();
  var k = viewK();
  var dpr = Math.min(window.devicePixelRatio || 1, 2.5);
  var px = W*k*dpr, py = H*k*dpr;
  var over = Math.sqrt((px*py) / PIXEL_BUDGET);
  if (over > 1){ px /= over; py /= over; }
  px = Math.max(1, Math.round(px)); py = Math.max(1, Math.round(py));
  if (artCanvas.width !== px || artCanvas.height !== py){ artCanvas.width = px; artCanvas.height = py; }
  artCanvas._scale = px / W;
}

/* Lay the flat artwork onto an angled face. The canvas keeps its own square
   coordinates -- only its painted result is warped -- so drawing, masking and
   the print file are untouched. The selection overlay gets the same warp in
   its own local coordinates, so the handles stay on the corners they mark. */
function applyPerspective(){
  var q = QUAD(), b = BOX(), ov = $("#overlay");
  if (!q){
    artCanvas.style.transform = "";
    if (ov) ov.style.transform = "";
    return;
  }
  var hc = solveH(boxPts(b), q);
  if (hc){
    artCanvas.style.transformOrigin = "0 0";
    artCanvas.style.transform = cssMatrix(hc);
  }
  if (ov){
    var local = q.map(function(p){ return [p[0]-b.x, p[1]-b.y]; });
    var ho = solveH([[0,0],[b.w,0],[b.w,b.h],[0,b.h]], local);
    if (ho){
      ov.style.transformOrigin = "0 0";
      ov.style.transform = cssMatrix(ho);
    }
  }
}

var rafPending = false;
function render(){
  if (!ready || rafPending) return;
  rafPending = true;
  requestAnimationFrame(function(){ rafPending = false; paintArt(actx, artCanvas._scale || 1); buildOverlay(); });
}
function applyCase(){ $("#mock").src = CC().img; }
function fullRefresh(){ applyCase(); layout(); render(); renderRail(); }

/* ---------- empty-case upload prompt ---------- */
var upEl = null;
(function buildUploader(){
  upEl = el("div", { class:"cs-upload", id:"stageUpload" });
  upEl.innerHTML =
    '<div class="cs-upload__hit">' +
      '<button type="button" class="cs-upload__b">' +
        '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
          '<path d="M12 16V4M12 4 7.5 8.5M12 4l4.5 4.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
          '<path d="M3.5 15v2.5A2.5 2.5 0 0 0 6 20h12a2.5 2.5 0 0 0 2.5-2.5V15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>' +
        '</svg>Add photo</button>' +
    '</div>';
  upEl.querySelector(".cs-upload__hit").addEventListener("click", function(ev){
    ev.preventDefault(); ev.stopPropagation();
    $("#fileInput").click();
  });
  $("#stage").appendChild(upEl);
})();
function placeUploader(){
  if (!upEl) return;
  upEl.hidden = S.layers.length > 0;
  if (upEl.hidden) return;
  var d = $("#device"), s = $("#stage");
  if (!d || !s) return;
  var dr = d.getBoundingClientRect(), sr = s.getBoundingClientRect();
  if (!dr.width) return;
  upEl.style.left = (dr.left - sr.left) + "px";
  upEl.style.top = (dr.top - sr.top) + "px";
  upEl.style.width = dr.width + "px";
  upEl.style.height = dr.height + "px";
  var b = BOX(), hit = upEl.firstChild;
  hit.style.left = (b.x / W * dr.width) + "px";
  hit.style.top = (b.y / H * dr.height) + "px";
  hit.style.width = (b.w / W * dr.width) + "px";
  hit.style.height = (b.h / H * dr.height) + "px";
}

/* ---------- pointer interaction ---------- */
var drag = null;
function stagePoint(ev){
  /* Measure against the un-warped mockup frame, not the canvas: once the
     canvas carries a perspective transform its own rect is the warped one. */
  var inner = $("#deviceInner"), r = inner.getBoundingClientRect(), b = BOX();
  if (!r.width) return { x:0, y:0 };
  var mx = (ev.clientX - r.left)/r.width*W, my = (ev.clientY - r.top)/r.height*H;
  var q = QUAD();
  if (q){
    var hi = solveH(q, boxPts(b));
    if (hi){ var p = applyH(hi, mx, my); mx = p[0]; my = p[1]; }
  }
  return { x: mx - b.x, y: my - b.y };
}
function hitLayer(p){
  var b = BOX();
  if (p.x < 0 || p.y < 0 || p.x > b.w || p.y > b.h) return null;
  for (var i=S.layers.length-1;i>=0;i--){
    var L = S.layers[i];
    if (L.type === "slot"){
      var r = cellRect(L);
      if (p.x >= r.x && p.x <= r.x+r.w && p.y >= r.y && p.y <= r.y+r.h) return L;
      continue;
    }
    var t = L.rot*Math.PI/180, cs = Math.cos(t), sn = Math.sin(t);
    var dx = p.x - L.x, dy = p.y - L.y;
    var lx = dx*cs + dy*sn, ly = -dx*sn + dy*cs;
    var bb = layerBox(L);
    if (Math.abs(lx) <= bb.w/2 && Math.abs(ly) <= bb.h/2) return L;
  }
  return null;
}
function setSel(id){
  if (S.sel === id) return;
  S.sel = id || 0;
  render(); renderRail();
}

$("#overlay").addEventListener("pointerdown", function(ev){
  if (pinch) return;
  var node = ev.target.closest ? ev.target.closest("[data-handle]") : null;
  var h = node && node.getAttribute("data-handle");
  var q = sel();
  if (!h || !q) return;
  ev.preventDefault(); ev.stopPropagation();
  if (h === "del"){ removeLayer(q.id); fullRefresh(); return; }
  var p = stagePoint(ev);
  drag = { mode: h === "rot" ? "rotate" : "scale",
    startAng: Math.atan2(p.y-q.y, p.x-q.x), startRot: q.rot,
    startDist: Math.hypot(p.x-q.x, p.y-q.y) || 1, startScale: q.scale };
  try { ev.target.setPointerCapture(ev.pointerId); } catch(e){}
});
$("#stage").addEventListener("pointerdown", function(ev){
  if (pinch) return;
  if (ev.target.closest && ev.target.closest("[data-handle]")) return;
  var p = stagePoint(ev);
  var L = hitLayer(p);
  if (!L){
    /* Zoomed in, empty space is the handle for moving the case around. A tap
       that does not travel still counts as "nothing selected". */
    if (view.zoom > ZOOM_MIN + 1e-4){
      drag = { mode:"view", sx:ev.clientX, sy:ev.clientY, px:view.px, py:view.py, moved:0 };
      try { $("#stage").setPointerCapture(ev.pointerId); } catch(e){}
      return;
    }
    setSel(0); return;
  }
  if (L.id !== S.sel){ S.sel = L.id; render(); renderRail(); }
  if (L.type === "slot"){
    if (!L.src){ pendingSlot = L.id; $("#fileInput").click(); return; }
    drag = { mode:"pan", startOx:L.ox, startOy:L.oy, startX:p.x, startY:p.y };
  } else {
    drag = { mode:"move", offX:L.x-p.x, offY:L.y-p.y };
  }
  try { $("#stage").setPointerCapture(ev.pointerId); } catch(e){}
});
document.addEventListener("pointerdown", function(ev){
  if (!S.sel) return;
  var st = $("#stage");
  if (st && (st === ev.target || st.contains(ev.target))) return;
  if (ROOT.contains(ev.target)) return;
  setSel(0);
}, true);
document.addEventListener("keydown", function(ev){
  if (!S.sel) return;
  var t = ev.target, tag = t && t.tagName;
  if (tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT") return;
  if (ev.key === "Escape") setSel(0);
  else if (ev.key === "Delete" || ev.key === "Backspace"){
    ev.preventDefault();
    var cur = sel();
    if (cur && cur.type === "slot"){ clearSlot(cur); render(); renderRail(); }
    else { removeLayer(S.sel); fullRefresh(); }
  }
});
window.addEventListener("pointermove", function(ev){
  if (drag && drag.mode === "view"){
    view.px = drag.px + (ev.clientX - drag.sx);
    view.py = drag.py + (ev.clientY - drag.sy);
    drag.moved = Math.max(drag.moved, Math.hypot(ev.clientX - drag.sx, ev.clientY - drag.sy));
    applyView();
    return;
  }
  var q = sel();
  if (!drag || !q) return;
  var p = stagePoint(ev);
  if (drag.mode === "pan"){
    var r = cellRect(q);
    q.ox = drag.startOx + (p.x - drag.startX)/r.w;
    q.oy = drag.startOy + (p.y - drag.startY)/r.h;
    clampPan(q);
  }
  else if (drag.mode === "move"){ q.x = p.x+drag.offX; q.y = p.y+drag.offY; }
  else if (drag.mode === "rotate"){
    var d = drag.startRot + (Math.atan2(p.y-q.y, p.x-q.x) - drag.startAng)*180/Math.PI;
    if (ev.shiftKey) d = Math.round(d/15)*15;
    q.rot = Math.round(d*10)/10;
  } else {
    q.scale = clamp(drag.startScale * (Math.hypot(p.x-q.x, p.y-q.y)/drag.startDist), .02, 24);
  }
  render();
});
window.addEventListener("pointerup", function(){
  if (!drag) return;
  var wasTap = drag.mode === "view" && drag.moved < 5;
  drag = null;
  if (wasTap) setSel(0);
  renderRail();
});

$("#stageWrap").addEventListener("wheel", function(ev){
  var q = sel();
  if (!q || !(ev.ctrlKey || ev.metaKey)) return;
  ev.preventDefault();
  if (q.type === "slot"){
    if (!q.src) return;
    q.zoom = clamp(q.zoom * (ev.deltaY < 0 ? 1.06 : 1/1.06), 1, 6);
    clampPan(q);
  } else {
    q.scale = clamp(q.scale * (ev.deltaY < 0 ? 1.06 : 1/1.06), .02, 24);
  }
  render(); renderRail();
}, { passive:false });

/* ---------- zooming the stage ---------- */
/* Two fingers zoom the design. Claiming the gesture here is also what stops
   Safari zooming the page: a pinch over a canvas carrying a perspective
   transform makes it re-rasterise at the zoomed size, and on a phone that is
   what was killing the tab. */
var pointers = {}, pinch = null;
function livePts(){
  var out = [], k;
  for (k in pointers) out.push(pointers[k]);
  return out;
}
function midOf(a, b){ return { x:(a.x+b.x)/2, y:(a.y+b.y)/2 }; }
function distOf(a, b){ return Math.hypot(a.x-b.x, a.y-b.y) || 1; }

$("#stage").addEventListener("pointerdown", function(ev){
  if (ev.pointerType === "mouse") return;
  pointers[ev.pointerId] = { x:ev.clientX, y:ev.clientY };
  var ps = livePts();
  if (ps.length === 2){
    drag = null;
    pinch = { d:distOf(ps[0], ps[1]), z:view.zoom,
              px:view.px, py:view.py, m:midOf(ps[0], ps[1]) };
  }
}, true);

window.addEventListener("pointermove", function(ev){
  if (!pointers[ev.pointerId]) return;
  pointers[ev.pointerId] = { x:ev.clientX, y:ev.clientY };
  if (!pinch) return;
  var ps = livePts();
  if (ps.length < 2) return;
  if (ev.cancelable) ev.preventDefault();
  var m = midOf(ps[0], ps[1]);
  view.px = pinch.px + (m.x - pinch.m.x);
  view.py = pinch.py + (m.y - pinch.m.y);
  setZoom(pinch.z * (distOf(ps[0], ps[1]) / pinch.d), m.x, m.y, true);
}, { passive:false, capture:true });

function dropPointer(ev){
  delete pointers[ev.pointerId];
  if (livePts().length < 2 && pinch){
    pinch = null;
    layout(); render();          /* sharpen back up once the fingers are off */
  }
}
window.addEventListener("pointerup", dropPointer, true);
window.addEventListener("pointercancel", dropPointer, true);

var wrapEl = $("#stageWrap");

/* Safari fires its own pinch events on top of the pointer ones. */
["gesturestart","gesturechange","gestureend"].forEach(function(t){
  wrapEl.addEventListener(t, function(ev){ ev.preventDefault(); }, { passive:false });
});

(function buildZoom(){
  var st = document.createElement("style");
  st.textContent =
    "#case-studio .cs-zoom{position:absolute;right:12px;bottom:12px;z-index:7;display:flex;align-items:center;gap:2px;padding:3px;border-radius:999px;background:rgba(16,16,18,.66);box-shadow:0 2px 12px rgba(0,0,0,.28);-webkit-backdrop-filter:blur(6px);backdrop-filter:blur(6px)}" +
    "#case-studio .cs-zoom button{min-width:32px;height:32px;padding:0 8px;border:0;border-radius:999px;background:transparent;color:#fff;font-family:inherit;font-size:14px;font-weight:600;line-height:1;cursor:pointer;-webkit-tap-highlight-color:transparent}" +
    "#case-studio .cs-zoom button:hover:not(:disabled){background:rgba(255,255,255,.16)}" +
    "#case-studio .cs-zoom button:disabled{opacity:.32;cursor:default}" +
    "#case-studio .cs-zoom .pct{min-width:46px;font-size:12px;font-variant-numeric:tabular-nums;letter-spacing:.02em}" +
    /* Where the case sits in the stage, and where this control sits on a
       phone, are the stylesheet's -- see case-studio-pro.css. */
    "#case-studio .stage-wrap.cs-zoomed .stage{cursor:grab}";
  document.head.appendChild(st);

  var box = document.createElement("div");
  box.className = "cs-zoom";
  box.innerHTML =
    '<button type="button" id="zoomOutBtn" aria-label="Zoom out">−</button>' +
    '<button type="button" class="pct" id="zoomPct" aria-label="Reset zoom">100%</button>' +
    '<button type="button" id="zoomIn" aria-label="Zoom in">+</button>';
  wrapEl.appendChild(box);
  box.addEventListener("pointerdown", function(ev){ ev.stopPropagation(); });
  box.querySelector("#zoomOutBtn").onclick = function(){ stepZoom(-1); };
  box.querySelector("#zoomIn").onclick = function(){ stepZoom(1); };
  box.querySelector("#zoomPct").onclick = function(){ resetZoom(); };
})();

["dragenter","dragover"].forEach(function(e){ wrapEl.addEventListener(e, function(ev){ ev.preventDefault(); wrapEl.classList.add("dragging"); }); });
wrapEl.addEventListener("dragleave", function(ev){ if (!wrapEl.contains(ev.relatedTarget)) wrapEl.classList.remove("dragging"); });
wrapEl.addEventListener("drop", function(ev){ ev.preventDefault(); wrapEl.classList.remove("dragging"); handleFiles(ev.dataTransfer && ev.dataTransfer.files); });

function handleFiles(files){
  if (!files || !files.length) return;
  var imgs = [];
  for (var i=0;i<files.length;i++) if (files[i].type.indexOf("image/") === 0) imgs.push(files[i]);
  if (!imgs.length){ pendingSlot = 0; return; }

  /* A tap on an empty collage cell claims the next picked photos, in order. */
  var slots = [];
  if (pendingSlot){
    var start = -1, all = S.layers.filter(function(L){ return L.type === "slot"; });
    for (var k=0;k<all.length;k++) if (all[k].id === pendingSlot) start = k;
    if (start > -1){
      for (var k2=start; k2<all.length && slots.length<imgs.length; k2++){
        if (k2 === start || !all[k2].src) slots.push(all[k2]);
      }
    }
    pendingSlot = 0;
  }

  var done = 0;
  function finish(){ if (++done === imgs.length){ if (!slots.length) tab = "photos"; fullRefresh(); } }

  imgs.forEach(function(f, n){
    var target = slots[n] || null;
    var url = URL.createObjectURL(f);
    var im = new Image();
    im.onload = function(){
      var nw = im.naturalWidth || 512, nh = im.naturalHeight || 512;
      var label = f.name.replace(/\.[^.]+$/,"");

      function use(src, keep){
        imgCache.set(src, keep);
        if (target) fillSlot(target, src, nw, nh, label, f);
        else addPhoto(src, nw, nh, label, f);
        finish();
      }

      /* A photo off a phone decodes to forty-odd megabytes. Two of those and a
         zoomed preview is enough for the browser to kill the tab, so what is
         held on screen is a working copy -- still finer than the print can
         use. The file itself is untouched, and that is what gets sent. */
      var lim = f.type === "image/png" ? 2000 : WORK_MAX;
      var sc = Math.min(1, lim / Math.max(nw, nh));
      if (sc >= 1){ use(url, im); return; }

      var c = document.createElement("canvas");
      c.width = Math.max(1, Math.round(nw*sc));
      c.height = Math.max(1, Math.round(nh*sc));
      c.getContext("2d").drawImage(im, 0, 0, c.width, c.height);
      /* Everything downstream asks an image for these, and a canvas draws the
         same way, so the working copy can stand in for one. */
      c.complete = true; c.naturalWidth = c.width; c.naturalHeight = c.height;
      var type = f.type === "image/png" ? "image/png" : "image/jpeg";
      if (c.toBlob){
        c.toBlob(function(b){
          if (!b){ use(url, im); return; }
          URL.revokeObjectURL(url);
          use(URL.createObjectURL(b), c);
        }, type, 0.92);
      } else {
        try { var d = c.toDataURL(type, 0.92); URL.revokeObjectURL(url); use(d, c); }
        catch(e){ use(url, im); }
      }
    };
    im.onerror = function(){ URL.revokeObjectURL(url); finish(); };
    im.src = url;
  });
}

/* ---------- case + model ---------- */
function magsafeOnly(){ return MAGSAFE_ONLY.indexOf(String(S.model).toLowerCase()) > -1; }
function allowedCases(){
  if (!magsafeOnly()) return CASES;
  var out = [];
  for (var i=0;i<CASES.length;i++) if (CASES[i].id === "magsafe") out.push(CASES[i]);
  return out.length ? out : CASES;
}
function buildCasePicker(){
  var box = $("#caseSeg");
  if (!box) return;
  box.innerHTML = "";
  allowedCases().forEach(function(c){
    var b = el("button", { class:"case-opt", type:"button", "data-c":c.id, "aria-pressed":String(c.id===S.caseId) });
    var crop = el("div", { class:"case-crop" });
    crop.style.backgroundImage = "url(" + c.img + ")";
    crop.style.backgroundPosition = c.crop;
    b.appendChild(crop);
    b.appendChild(el("div",{class:"case-name"}, c.name));
    b.onclick = function(){ switchCase(c.id); };
    box.appendChild(b);
  });
}
function switchCase(id){
  if (id === S.caseId) return;
  var o = BOX(), n = null;
  for (var i=0;i<CASES.length;i++) if (CASES[i].id === id) n = CASES[i].box;
  var rx = n.w/o.w, ry = n.h/o.h, k = Math.max(rx, ry);
  S.layers.forEach(function(L){ L.x *= rx; L.y *= ry; L.scale *= k; });
  S.caseId = id;
  fullRefresh();
}
function buildModelPicker(){
  var host = $("#modelBox");
  if (!host || $("#modelSel")) return;
  if (!HAS_MODELS){ host.innerHTML = ""; return; }
  host.innerHTML =
    '<div class="cs-model-wrap"><select id="modelSel" class="cs-model" aria-label="' + esc(MODEL_LABEL) + '">' +
      MODELS.map(function(m){ return '<option value="' + esc(m) + '">' + esc(m) + '</option>'; }).join("") +
    '</select></div><div class="cs-note" id="modelNote"></div>';
  $("#modelSel").onchange = function(ev){ setModel(ev.target.value); };
}
function setModel(m){
  S.model = m;
  var ok = allowedCases(), has = false, i;
  for (i=0;i<ok.length;i++) if (ok[i].id === S.caseId) has = true;
  buildCasePicker();
  if (has) fullRefresh(); else switchCase(ok[0].id);
}
function renderModel(){
  var s = $("#modelSel"), note = $("#modelNote"), crumb = $("#crumbTitle");
  if (s && s.value !== S.model) s.value = S.model;
  if (crumb) crumb.textContent = HAS_MODELS ? S.model : TITLE;
  if (!note) return;
  var txt = "Preview is shown on the " + PREVIEW_MODEL + ". Templates for the other models are coming soon -- your case is made for the model you pick.";
  if (magsafeOnly()) txt += " The " + S.model + " is available in Tough MagSafe only.";
  note.textContent = txt;
}

/* ---------- rail ---------- */
var TABS = [
  { id:"photos",   label:"Photos" },
  { id:"collage",  label:"Collage" },
  { id:"text",     label:"Text" }
];
if (STICKERS.length) TABS.push({ id:"stickers", label:"Stickers" });
TABS.push({ id:"emoji", label:"Emojis" });
/* ---------- case background ---------- */
function buildBg(){
  var host = $("#bgBox");
  if (!host || host.firstChild) return;
  var row = el("div", { class:"cs-bg" });

  var none = el("button", { class:"cs-sw cs-sw--none", type:"button",
                            "data-c":"", title:"No background",
                            "aria-label":"No background — leave the " + NOUN + " as it is" });
  none.onclick = function(){ setBg(""); };
  row.appendChild(none);

  BG_COLORS.forEach(function(c){
    var b = el("button", { class:"cs-sw", type:"button", "data-c":String(c).toLowerCase(),
                           title:c, "aria-label":"Background " + c });
    b.style.background = c;
    b.onclick = function(){ setBg(c); };
    row.appendChild(b);
  });

  var pick = el("label", { class:"cs-sw cs-sw--pick", title:"Pick any colour" });
  var inp = el("input", { type:"color", value:"#3FA0F0", "aria-label":"Pick any background colour" });
  inp.oninput = function(){ setBg(inp.value); };
  pick.appendChild(inp);
  row.appendChild(pick);

  host.appendChild(row);
}
function setBg(c){
  S.bg = c || "";
  markBg();
  render();
  renderRail();
}
function markBg(){
  Array.prototype.forEach.call($$("#bgBox button.cs-sw"), function(b){
    b.setAttribute("aria-pressed", String((b.getAttribute("data-c") || "") === String(S.bg).toLowerCase()));
  });
}

function buildTabs(){
  var bar = $("#tabBar");
  bar.innerHTML = "";
  bar.style.gridTemplateColumns = "repeat(" + TABS.length + ",minmax(0,1fr))";
  TABS.forEach(function(t){
    var b = el("button", { class:"cs-tab", type:"button", "data-tab":t.id }, t.label);
    b.onclick = function(){ tab = t.id; renderRail(); };
    bar.appendChild(b);
  });
}
function renderRail(){
  var C = CC();
  $("#priceOut").textContent = money(C.price);
  $("#footName").textContent = HAS_MODELS ? (C.name + " case") : C.name;
  $("#footPrice").textContent = money(C.price);
  renderModel();
  hint();
  Array.prototype.forEach.call($$("#caseSeg .case-opt"), function(b){ b.setAttribute("aria-pressed", String(b.getAttribute("data-c") === S.caseId)); });
  Array.prototype.forEach.call($$("#tabBar .cs-tab"), function(b){ b.setAttribute("aria-selected", String(b.getAttribute("data-tab") === tab)); });
  markBg();
  var filled = S.layers.some(function(L){ return L.type !== "slot" || !!L.src; });
  var any = (S.layers.length > 0 && filled) || !!S.bg;
  $("#cartBtn").disabled = !any;
  $("#cartBtn2").disabled = !any;
  if (EDIT){ $("#cartBtn").textContent = "Update cart"; $("#cartBtn2").textContent = "Update cart"; }
  renderTab();
  renderLayers();
  renderProps();
  placeUploader();
}
function hint(){
  var h = $("#stageHint");
  if (!h) return;
  var cur = sel();
  if (cur && cur.type === "slot"){
    h.textContent = cur.src
      ? "Drag the photo to move it inside its cell · Delete to clear it"
      : "Tap the cell to choose a photo";
    return;
  }
  if (cur){
    h.textContent = "Drag to move · corners to resize · top handle to rotate · red × to delete";
    return;
  }
  var free = S.layers.filter(function(L){ return L.type !== "slot"; }).length;
  var slots = S.layers.filter(function(L){ return L.type === "slot"; });
  var empties = slots.filter(function(L){ return !L.src; }).length;
  if (empties) h.textContent = "Tap a cell to add a photo";
  else if (free || slots.length) h.textContent = "Tap anything on the " + NOUN + " to edit it";
  else h.textContent = "Tap the " + NOUN + " to add your photo";
}

/* The tab panel is static per tab, so only rebuild it when the tab changes --
   otherwise every drag would reset the emoji category and re-fetch art. */
var tabRendered = null;
function renderTab(){
  if (tabRendered === tab) return;
  tabRendered = tab;
  var box = $("#tabPanel");
  box.innerHTML = "";
  if (tab === "photos"){
    var add = el("button",{class:"btn btn-block",type:"button"},"Add a photo");
    add.onclick = function(){ $("#fileInput").click(); };
    box.appendChild(add);
    box.appendChild(el("p",{class:"cs-tip"},"You can add as many photos as you like, and drag more onto the " + NOUN + "."));
  } else if (tab === "text"){
    var t = el("button",{class:"btn btn-block",type:"button"},"Add text");
    t.onclick = function(){ addText(); fullRefresh(); };
    box.appendChild(t);
    box.appendChild(el("p",{class:"cs-tip"},"Add as many lines as you want. Pick the font, colour, size and curve below."));
  } else if (tab === "collage"){
    var grid = el("div",{class:"cs-lays"});

    var none = el("button",{class:"cs-lay",type:"button","aria-pressed":String(!S.layout)});
    var nt = el("div",{class:"cs-lay__t cs-lay__t--none"});
    nt.appendChild(el("span",{class:"cs-lay__x"}));
    none.appendChild(nt);
    none.appendChild(el("div",{class:"cs-lay__n"},"None"));
    none.onclick = function(){ applyLayout(""); fullRefresh(); };
    grid.appendChild(none);

    LAYOUTS.forEach(function(lay){
      var b = el("button",{class:"cs-lay",type:"button","aria-pressed":String(lay.id===S.layout),title:lay.name});
      var t = el("div",{class:"cs-lay__t"});
      lay.cells.forEach(function(c){
        var cell = el("span");
        cell.style.left = (c[0]*100) + "%";
        cell.style.top = (c[1]*100) + "%";
        cell.style.width = (c[2]*100) + "%";
        cell.style.height = (c[3]*100) + "%";
        t.appendChild(cell);
      });
      b.appendChild(t);
      b.appendChild(el("div",{class:"cs-lay__n"}, esc(lay.name)));
      b.onclick = function(){ applyLayout(lay.id); fullRefresh(); };
      grid.appendChild(b);
    });

    box.appendChild(grid);
    box.appendChild(el("p",{class:"cs-tip"},
      S.layout ? ("Tap a cell on the " + NOUN + " to fill it. Drag a photo to reposition it inside its cell.")
               : "Pick a layout, then tap each cell to drop a photo in. Text, stickers and emoji still go anywhere on top."));

  } else if (tab === "stickers"){
    if (!STICKERS.length){
      box.appendChild(el("p",{class:"cs-tip"},"No stickers yet. Add their image URLs in the section settings and they'll show up here."));
    } else {
      var g = el("div",{class:"cs-grid"});
      STICKERS.forEach(function(s){
        var b = el("button",{class:"cs-chip",type:"button",title:s.name||""});
        var im = el("img"); im.src = s.url; im.alt = s.name || ""; im.loading = "lazy";
        b.appendChild(im);
        b.onclick = function(){
          loadArt(s.url).then(function(img){
            addArt(img, s.url, s.name || "Sticker");
            fullRefresh();
          }).catch(function(){});
        };
        g.appendChild(b);
      });
      box.appendChild(g);
    }
  } else if (tab === "emoji"){
    var cats = CFG.emoji || [];
    var catBar = el("div",{class:"cs-chips"});
    var grid = el("div",{class:"cs-grid cs-grid--emoji"});
    var active = 0;
    function paintCat(){
      grid.innerHTML = "";
      Array.prototype.forEach.call(catBar.children, function(c,i){ c.setAttribute("aria-pressed", String(i===active)); });
      (cats[active] ? cats[active].items : []).forEach(function(code){
        var ch = emojiChar(code);
        var b = el("button",{class:"cs-chip cs-chip--emoji",type:"button"});
        b.textContent = ch;
        b.onclick = function(){ addEmoji(ch); fullRefresh(); };
        grid.appendChild(b);
      });
    }
    cats.forEach(function(c,i){
      var b = el("button",{class:"cs-cat",type:"button"}, esc(c.name));
      b.onclick = function(){ active = i; paintCat(); };
      catBar.appendChild(b);
    });
    box.appendChild(catBar);
    box.appendChild(grid);
    paintCat();
  }
}

function layerLabel(L){
  if (L.type === "text") return (L.text || "Text").split("\n")[0].slice(0, 22) || "Text";
  if (L.type === "emoji") return L.ch;
  return L.name || (L.type === "photo" ? "Photo" : "Sticker");
}
function renderLayers(){
  var sec = $("#layerSec"), box = $("#layerList");
  var free = S.layers.filter(function(L){ return L.type !== "slot"; });
  sec.hidden = !free.length;
  box.innerHTML = "";
  for (var i=S.layers.length-1;i>=0;i--){
    if (S.layers[i].type === "slot") continue;
    (function(L, i){
      var row = el("div",{class:"cs-layer" + (L.id===S.sel ? " is-on" : "")});
      var th = el("div",{class:"cs-layer__t"});
      if (L.type === "text"){ th.textContent = "T"; th.className += " cs-layer__t--text"; }
      else if (L.type === "emoji"){ th.textContent = L.ch; th.className += " cs-layer__t--emoji"; }
      else { var im = el("img"); im.src = L.src; im.alt=""; th.appendChild(im); }
      row.appendChild(th);
      row.appendChild(el("div",{class:"cs-layer__n"}, esc(layerLabel(L))));

      var up = el("button",{class:"cs-ico",type:"button",title:"Bring forward","aria-label":"Bring forward"},"&#9650;");
      up.disabled = i === S.layers.length-1;
      up.onclick = function(e){ e.stopPropagation(); moveLayer(L.id, 1); render(); renderRail(); };
      var dn = el("button",{class:"cs-ico",type:"button",title:"Send back","aria-label":"Send back"},"&#9660;");
      dn.disabled = i === 0;
      dn.onclick = function(e){ e.stopPropagation(); moveLayer(L.id, -1); render(); renderRail(); };
      var du = el("button",{class:"cs-ico",type:"button",title:"Duplicate","aria-label":"Duplicate"},"&#10697;");
      du.onclick = function(e){ e.stopPropagation(); duplicateLayer(L.id); fullRefresh(); };
      var rm = el("button",{class:"cs-ico cs-ico--del",type:"button",title:"Delete","aria-label":"Delete"},"&times;");
      rm.onclick = function(e){ e.stopPropagation(); removeLayer(L.id); fullRefresh(); };

      row.appendChild(up); row.appendChild(dn); row.appendChild(du); row.appendChild(rm);
      row.onclick = function(){ setSel(L.id); };
      box.appendChild(row);
    })(S.layers[i], i);
  }
}

function field(label, valueText){
  var f = el("div",{class:"field"});
  f.innerHTML = '<div class="field-label">' + esc(label) + ' <span class="field-val">' + esc(valueText || "") + '</span></div>';
  return f;
}
function renderProps(){
  var sec = $("#propSec"), box = $("#propBox");
  var L = sel();
  sec.hidden = !L;
  box.innerHTML = "";
  if (!L) return;

  if (L.type === "slot"){
    if (!L.src){
      var pick = el("button",{class:"btn btn-block",type:"button"},"Add a photo to this cell");
      pick.onclick = function(){ pendingSlot = L.id; $("#fileInput").click(); };
      box.appendChild(pick);
      box.appendChild(el("p",{class:"cs-tip"},"Or tap the cell on the " + NOUN + "."));
      return;
    }
    var zf = field("Zoom", Math.round(L.zoom*100) + "%");
    var zr = el("input",{type:"range",min:"100",max:"400",step:"1","aria-label":"Zoom"});
    zr.value = String(Math.round(L.zoom*100));
    zr.oninput = function(e){ L.zoom = (+e.target.value)/100; clampPan(L); render(); renderProps(); };
    zf.appendChild(zr);
    box.appendChild(zf);
    box.appendChild(el("p",{class:"cs-tip"},"Drag the photo on the " + NOUN + " to reposition it inside its cell."));

    var row2 = el("div",{class:"grid2",style:"margin-top:12px"});
    var rep = el("button",{class:"btn btn-sm",type:"button"},"Replace");
    rep.onclick = function(){ pendingSlot = L.id; $("#fileInput").click(); };
    var clr = el("button",{class:"btn btn-sm",type:"button"},"Clear");
    clr.onclick = function(){ clearSlot(L); render(); renderRail(); };
    row2.appendChild(rep); row2.appendChild(clr);
    box.appendChild(row2);
  }

  if (L.type === "photo" || (L.type === "slot" && L.src)){
    if (CAN_FILTER){
      box.appendChild(el("div",{class:"sec-sub",style:"margin-top:16px"},"Filter"));
      var fg = el("div",{class:"cs-filters"});
      FILTERS.forEach(function(f){
        var b = el("button",{class:"cs-filter",type:"button","aria-pressed":String(f.id===L.filter)});
        var th = el("div",{class:"cs-filter__t"});
        th.style.backgroundImage = "url(" + L.src + ")";
        th.style.filter = f.css;
        b.appendChild(th);
        b.appendChild(el("div",{class:"cs-filter__n"}, f.name));
        b.onclick = function(){ L.filter = f.id; render(); renderProps(); };
        fg.appendChild(b);
      });
      box.appendChild(fg);
    }
  }

  if (L.type === "text"){
    var ta = el("textarea",{class:"cs-input",rows:"2","aria-label":"Text"});
    ta.value = L.text;
    ta.oninput = function(e){ L.text = e.target.value; measureText(L); render(); };
    ta.onchange = function(){ renderLayers(); };
    box.appendChild(ta);

    var fw = el("div",{class:"cs-model-wrap",style:"margin-top:10px"});
    var fs = el("select",{class:"cs-model","aria-label":"Font"});
    FONTS.forEach(function(f){
      var o = el("option",{value:f.css}, esc(f.name));
      o.style.fontFamily = f.css;
      fs.appendChild(o);
    });
    fs.value = L.font;
    fs.onchange = function(e){
      L.font = e.target.value;
      loadFont(L).then(function(){ measureText(L); render(); });
    };
    fw.appendChild(fs);
    box.appendChild(fw);

    var row = el("div",{class:"cs-row"});
    var bBold = el("button",{class:"cs-toggle",type:"button","aria-pressed":String(!!L.bold)},"<b>B</b>");
    bBold.onclick = function(){ L.bold = !L.bold; loadFont(L).then(function(){ measureText(L); render(); renderProps(); }); };
    var bIt = el("button",{class:"cs-toggle",type:"button","aria-pressed":String(!!L.italic)},"<i>I</i>");
    bIt.onclick = function(){ L.italic = !L.italic; loadFont(L).then(function(){ measureText(L); render(); renderProps(); }); };
    var col = el("input",{class:"cs-color",type:"color","aria-label":"Colour"});
    col.value = L.color;
    col.oninput = function(e){ L.color = e.target.value; render(); };
    row.appendChild(bBold); row.appendChild(bIt); row.appendChild(col);
    box.appendChild(row);

    var fc = field("Curve", String(Math.round(L.curve)));
    var rc = el("input"); rc.type="range"; rc.min=-100; rc.max=100; rc.step=1; rc.value=Math.round(L.curve);
    rc.oninput = function(e){ L.curve = +e.target.value; fc.querySelector(".field-val").textContent = e.target.value; measureText(L); render(); };
    fc.appendChild(rc); box.appendChild(fc);
  }

  /* 100% = fills the case (photo) or the default size (text/sticker) */
  var b = BOX();
  var refS = L.type === "photo" ? Math.max(b.w/L.w, b.h/L.h)
           : L.type === "text"  ? (b.w*0.72)/Math.max(1,L.w)
                                : (b.w*0.34)/Math.max(1,L.w);
  if (L.type === "emoji") refS = (b.w*0.34)/Math.max(1,L.w);
  var pctOf = function(){ return Math.max(1, Math.round(L.scale/refS*100)) + "%"; };
  var f1 = field("Size", pctOf());
  var r1 = el("input"); r1.type="range"; r1.min=10; r1.max=320; r1.step=1;
  r1.value = clamp(Math.round(L.scale/refS*100), 10, 320);
  r1.oninput = function(e){
    L.scale = clamp(refS * (+e.target.value/100), .02, 24);
    f1.querySelector(".field-val").textContent = pctOf();
    render();
  };
  f1.appendChild(r1); box.appendChild(f1);

  var f2 = field("Rotation", Math.round(L.rot) + "°");
  var r2 = el("input"); r2.type="range"; r2.min=-180; r2.max=180; r2.step=1; r2.value=Math.round(L.rot);
  r2.oninput = function(e){ L.rot = +e.target.value; f2.querySelector(".field-val").textContent = e.target.value + "°"; render(); };
  f2.appendChild(r2); box.appendChild(f2);

  var g = el("div",{class:"grid2",style:"margin-top:14px"});
  var fill = el("button",{class:"btn btn-sm",type:"button"}, L.type === "photo" ? ("Fill " + NOUN) : "Centre");
  fill.onclick = function(){
    var bb = BOX();
    L.x = bb.w/2; L.y = bb.h/2; L.rot = 0;
    if (L.type === "photo") L.scale = Math.max(bb.w/L.w, bb.h/L.h);
    render(); renderRail();
  };
  var rm2 = el("button",{class:"btn btn-sm",type:"button"},"Delete");
  rm2.onclick = function(){ removeLayer(L.id); fullRefresh(); };
  g.appendChild(fill); g.appendChild(rm2);
  box.appendChild(g);

  if (L.type === "photo"){
    var dpi = Math.round(dpiOf(L));
    if (dpi && dpi < 300){
      var w = el("div",{class:"warn" + (dpi < 150 ? " bad" : ""), style:"margin-top:10px"});
      w.textContent = dpi < 150
        ? "This photo is small for the size you've set and will print blurry. Zoom out, or use a larger photo."
        : "Slightly soft at this size. Zooming out a little will sharpen the print.";
      box.appendChild(w);
    }
  }
}
function dpiOf(L){
  var C = CC();
  if (!L || L.type !== "photo") return null;
  return L.natW / (((L.w*L.scale)/C.box.w * C.mmW)/25.4);
}
function loadFont(L){
  if (!document.fonts || !document.fonts.load) return Promise.resolve();
  try { return document.fonts.load(fontSpec(L, TEXT_BASE), L.text || "Ag"); }
  catch(e){ return Promise.resolve(); }
}

/* ---------- export ----------
   Two files come out of the same drawing. The masked one is cut to the shape
   of the case -- camera hole, rounded corners, side notch -- and is what the
   design looks like. The unmasked one is the plain rectangle the printer
   needs: nothing knocked out, the artwork carrying straight through where the
   hole would be, so the machine has a complete image to lay down. */
function exportPrint(scale, masked){
  var C = CC(), b = C.box;
  var c = document.createElement("canvas");
  c.width = Math.round(b.w*scale); c.height = Math.round(b.h*scale);
  var x = c.getContext("2d");
  x.save(); x.scale(scale,scale);
  if (S.bg){ x.fillStyle = S.bg; x.fillRect(0,0,b.w,b.h); }
  for (var i=0;i<S.layers.length;i++) drawLayer(x, S.layers[i], true);
  x.restore();
  if (masked === false) return c;
  var mk = imgCache.get(C.mask);
  if (mk && mk.complete && mk.naturalWidth){
    var ms = mk.naturalWidth / W;
    x.globalCompositeOperation = "destination-in";
    x.drawImage(mk, b.x*ms, b.y*ms, b.w*ms, b.h*ms, 0, 0, c.width, c.height);
    x.globalCompositeOperation = "source-over";
  }
  return c;
}
/* Canvas 2D has no perspective transform, so the warp the browser does with
   matrix3d is reproduced here as a mesh of triangles, each drawn under its own
   affine. 24x24 cells is well past the point where the seams are visible. */
function drawWarped(ctx, art, b, q, k){
  var N = 24, h = solveH([[0,0],[b.w,0],[b.w,b.h],[0,b.h]], q);
  if (!h){ ctx.drawImage(art, 0, 0); return; }
  var P = [], iy, ix;
  for (iy=0; iy<=N; iy++){
    P[iy] = [];
    for (ix=0; ix<=N; ix++){
      var p = applyH(h, b.w*ix/N, b.h*iy/N);
      P[iy][ix] = [p[0]*k, p[1]*k];
    }
  }
  var sw = art.width/N, sh = art.height/N;
  function tri(d0,d1,d2, s0,s1,s2){
    var x0=s0[0],y0=s0[1], x1=s1[0],y1=s1[1], x2=s2[0],y2=s2[1];
    var det = (x1-x0)*(y2-y0) - (x2-x0)*(y1-y0);
    if (!det) return;
    var a = ((d1[0]-d0[0])*(y2-y0) - (d2[0]-d0[0])*(y1-y0)) / det;
    var c = ((d2[0]-d0[0])*(x1-x0) - (d1[0]-d0[0])*(x2-x0)) / det;
    var bb= ((d1[1]-d0[1])*(y2-y0) - (d2[1]-d0[1])*(y1-y0)) / det;
    var d = ((d2[1]-d0[1])*(x1-x0) - (d1[1]-d0[1])*(x2-x0)) / det;
    ctx.save();
    ctx.beginPath();
    /* nudge each vertex outward so neighbouring cells overlap by a hair */
    var cx = (d0[0]+d1[0]+d2[0])/3, cy = (d0[1]+d1[1]+d2[1])/3, g = 0.6;
    var pts = [d0,d1,d2].map(function(p){
      var vx = p[0]-cx, vy = p[1]-cy, m = Math.sqrt(vx*vx+vy*vy) || 1;
      return [p[0] + vx/m*g, p[1] + vy/m*g];
    });
    ctx.moveTo(pts[0][0], pts[0][1]);
    ctx.lineTo(pts[1][0], pts[1][1]);
    ctx.lineTo(pts[2][0], pts[2][1]);
    ctx.closePath(); ctx.clip();
    ctx.transform(a, bb, c, d, d0[0]-a*x0-c*y0, d0[1]-bb*x0-d*y0);
    ctx.drawImage(art, 0, 0);
    ctx.restore();
  }
  for (iy=0; iy<N; iy++) for (ix=0; ix<N; ix++){
    var sx = ix*sw, sy = iy*sh;
    tri(P[iy][ix], P[iy][ix+1], P[iy+1][ix],
        [sx,sy], [sx+sw,sy], [sx,sy+sh]);
    tri(P[iy][ix+1], P[iy+1][ix+1], P[iy+1][ix],
        [sx+sw,sy], [sx+sw,sy+sh], [sx,sy+sh]);
  }
}
function previewCanvas(){
  var c = document.createElement("canvas");
  var pw = 620, ph = Math.round(620 * H / W);
  c.width = pw; c.height = ph;
  var x = c.getContext("2d");
  var base = imgCache.get(CC().img);
  if (base && base.complete) x.drawImage(base, 0, 0, pw, ph);
  var q = QUAD(), b = BOX(), k = pw / W;
  if (q){
    var art = exportPrint(k);          /* box-sized and already masked */
    x.save();
    x.translate(0, 0);
    drawWarped(x, art, b, q, k);
    x.restore();
  } else {
    var flat = document.createElement("canvas");
    flat.width = pw; flat.height = ph;
    paintArt(flat.getContext("2d"), k);
    x.drawImage(flat, 0, 0);
  }
  return c;
}
function toBlob(canvas){ return new Promise(function(res){ canvas.toBlob(res, "image/png"); }); }

function designId(){
  var s = JSON.stringify({ c:S.caseId, m:S.model, n:S.layers.length, t:Date.now() });
  var h = 0x811c9dc5;
  for (var i=0;i<s.length;i++){ h ^= s.charCodeAt(i); h = Math.imul(h, 0x01000193); }
  return (h>>>0).toString(16);
}
/* Layers are stored resolution-independently: printed width/height in
   print-box units, so a re-encoded source photo still lands identically. */
function designPayload(){
  var r2 = function(v){ return Math.round(v*100)/100; };
  return JSON.stringify({
    c: S.caseId, m: S.model, bg: S.bg, lay: S.layout,
    l: S.layers.map(function(L, i){
      if (L.type === "slot"){
        return { t:"slot", cl:L.cell.map(function(v){ return Math.round(v*1e4)/1e4; }),
                 z:r2(L.zoom), ox:r2(L.ox), oy:r2(L.oy),
                 fl:L.filter, i:i, n:L.name, s:L.src ? 1 : 0 };
      }
      var o = { t:L.type, x:r2(L.x), y:r2(L.y), r:L.rot,
                dw:r2(L.w*L.scale), dh:r2(L.h*L.scale) };
      if (L.type === "text"){
        o.tx = L.text; o.f = L.font; o.col = L.color;
        o.b = L.bold ? 1 : 0; o.it = L.italic ? 1 : 0; o.cu = L.curve;
      } else if (L.type === "photo"){
        o.fl = L.filter; o.i = i; o.n = L.name;
      } else if (L.type === "emoji"){
        o.e = L.ch;
      } else {
        o.u = L.ref || L.src; o.n = L.name;
      }
      return o;
    })
  });
}
function sourceBlobFor(L){
  if (L.url || !L.file) return Promise.resolve(null);
  if (L.file.size <= 8*1024*1024) return Promise.resolve(L.file);
  return new Promise(function(res){
    var im = imgCache.get(L.src);
    if (!im || !im.complete){ res(null); return; }
    var iw = im.naturalWidth || im.width || 1, ih = im.naturalHeight || im.height || 1;
    var sc = Math.min(1, 2400/Math.max(iw, ih));
    var c = document.createElement("canvas");
    c.width = Math.max(1, Math.round(iw*sc));
    c.height = Math.max(1, Math.round(ih*sc));
    c.getContext("2d").drawImage(im, 0, 0, c.width, c.height);
    c.toBlob(function(b){ res(b); }, "image/jpeg", 0.92);
  });
}

function restoreFromCart(){
  return fetch("/cart.js", { headers:{ "Accept":"application/json" }, credentials:"same-origin" })
    .then(function(r){ return r.json(); })
    .then(function(c){
      var it = null, i;
      for (i=0;i<c.items.length;i++) if (c.items[i].key === EDIT_KEY) it = c.items[i];
      if (!it || !it.properties) return null;
      var d = null;
      try { d = JSON.parse(it.properties["_design"]); } catch(e){ d = null; }
      if (!d || !d.l) return null;
      for (i=0;i<CASES.length;i++) if (CASES[i].id === d.c) S.caseId = d.c;
      if (d.m && MODELS.indexOf(d.m) > -1) S.model = d.m;
      if (typeof d.bg === "string") S.bg = d.bg;
      if (typeof d.lay === "string") S.layout = d.lay;
      EDIT = { key: it.key, qty: it.quantity || 1 };

      return Promise.all(d.l.map(function(o){
        if (o.t === "text"){
          var L = { id:++seq, type:"text", text:o.tx || "", font:o.f, color:o.col || "#fff",
                    bold:!!o.b, italic:!!o.it, curve:o.cu || 0, w:0, h:0,
                    x:o.x, y:o.y, rot:o.r || 0, scale:1 };
          return loadFont(L).then(function(){
            measureText(L);
            L.scale = (o.dw || L.w) / Math.max(1, L.w);
            return L;
          });
        }
        if (o.t === "emoji"){
          var E = { id:++seq, type:"emoji", ch:o.e || "", name:o.e || "", w:0, h:0,
                    x:o.x, y:o.y, rot:o.r || 0, scale:1 };
          measureEmoji(E);
          E.scale = (o.dw || E.w) / Math.max(1, E.w);
          return E;
        }
        if (o.t === "slot"){
          var K = { id:++seq, type:"slot", cell:(o.cl || [0,0,1,1]).slice(),
                    src:"", ref:"", url:"", file:null, name:o.n || "",
                    natW:0, natH:0, filter:o.fl || "original",
                    zoom:o.z || 1, ox:o.ox || 0, oy:o.oy || 0 };
          var su = o.s ? it.properties["_src" + o.i] : "";
          if (!su) return K;
          return loadArt(su).then(function(im){
            K.src = im.src; K.ref = su; K.url = su;
            K.natW = im.naturalWidth || 1; K.natH = im.naturalHeight || 1;
            return K;
          }).catch(function(){ return K; });
        }
        var url = o.t === "photo" ? it.properties["_src" + o.i] : o.u;
        if (!url) return null;
        return loadArt(url).then(function(im){
          var nw = im.naturalWidth || 512, nh = im.naturalHeight || 512;
          return { id:++seq, type:o.t, src:im.src, ref:url, url:url, file:null, name:o.n || "",
                   natW:nw, natH:nh, w:nw, h:nh, filter:o.fl || "original",
                   x:o.x, y:o.y, rot:o.r || 0,
                   scale:(o.dw || nw) / Math.max(1, nw) };
        }).catch(function(){ return null; });
      })).then(function(list){
        S.layers = list.filter(Boolean);
        S.sel = 0;
        return null;
      });
    })
    .catch(function(){ return null; });
}

/* A line of plain English describing what was made. The artwork and the
   preview ride along as files, but a file is a link someone has to open --
   this is what the order itself says, in the cart, in the confirmation email
   and in the admin. */
function designSummary(){
  var texts = [], photos = 0, stickers = 0, emojis = [], cells = 0, filled = 0;
  S.layers.forEach(function(L){
    if (L.type === "text"){
      var t = String(L.text || "").replace(/\s+/g, " ").trim();
      if (t) texts.push('"' + t + '"');
    }
    else if (L.type === "photo") photos++;
    else if (L.type === "sticker") stickers++;
    else if (L.type === "emoji") emojis.push(L.ch);
    else if (L.type === "slot"){ cells++; if (L.src) filled++; }
  });
  var bits = [];
  if (texts.length) bits.push("Text " + texts.join(" + "));
  if (cells) bits.push("Collage, " + filled + " of " + cells + " photos");
  else if (photos) bits.push(photos + (photos === 1 ? " photo" : " photos"));
  if (stickers) bits.push(stickers + (stickers === 1 ? " sticker" : " stickers"));
  if (emojis.length) bits.push("Emoji " + emojis.join(""));
  if (S.bg) bits.push("Background " + S.bg);
  return bits.join(" / ");
}

/* ---------- cart ---------- */
var submitting = false;
function showCart(){
  if (submitting) return;
  /* A background colour on its own is a design too -- the button is enabled
     for it, so the send must accept it rather than silently doing nothing. */
  var hasArt = S.layers.some(function(L){ return L.type !== "slot" || !!L.src; });
  if (!hasArt && !S.bg) return;
  var C = CC();
  if (!C.variantId){ cartError("This " + NOUN + " has no variant set up yet."); return; }
  submitting = true;
  ROOT.classList.add("cs-busy");

  var drawerState = null;
  var id = designId();
  var want = Math.min((C.mmW / 25.4) * CFG.printDpi / C.box.w, 3.4);
  /* Cells carry their own uploads, same as loose photos. */
  var photos = S.layers.filter(function(L){
    return L.type === "photo" || (L.type === "slot" && L.src);
  });

  var fontsReady = (document.fonts && document.fonts.ready) ? document.fonts.ready : Promise.resolve();

  fontsReady
    .then(function(){ return Promise.all(photos.map(sourceBlobFor)); })
    .then(function(srcBlobs){
      return Promise.all([
        toBlob(exportPrint(want)),           /* cut to the case */
        toBlob(exportPrint(want, false)),    /* the rectangle the printer takes */
        toBlob(previewCanvas())
      ]).then(function(parts){
        var fd = new FormData();
        fd.append("id", String(C.variantId));
        fd.append("quantity", String(EDIT ? EDIT.qty : 1));
        /* The theme renders the drawer for us in the same round trip. */
        fd.append("sections", DRAWER_SECTIONS);
        fd.append("sections_url", window.location.pathname);
        if (HAS_MODELS) fd.append("properties[" + MODEL_LABEL + "]", S.model);
        fd.append("properties[_design_id]", id);
        fd.append("properties[_design]", designPayload());
        var made = designSummary();
        if (made) fd.append("properties[Design]", made);
        if (PREORDER) fd.append("properties[Delivery]", PREORDER);
        S.layers.forEach(function(L, i){
          if (L.type !== "photo" && !(L.type === "slot" && L.src)) return;
          var k = photos.indexOf(L);
          if (L.url){ fd.append("properties[_src" + i + "]", L.url); return; }
          var blob = srcBlobs[k];
          if (!blob) return;
          var t = blob.type, ext = t === "image/png" ? ".png" : (t === "image/webp" ? ".webp" : ".jpg");
          fd.append("properties[_src" + i + "]", blob, "source-" + id + "-" + i + ext);
        });
        if (parts[0]) fd.append("properties[Artwork]", parts[0], "print-" + id + ".png");
        if (parts[1]) fd.append("properties[To print]", parts[1], "toprint-" + id + ".png");
        if (parts[2]) fd.append("properties[Preview]", parts[2], "preview-" + id + ".png");
        return fetch(CFG.routes.cartAdd, {
          method:"POST", body:fd, credentials:"same-origin", headers:{ "Accept":"application/json" }
        }).then(function(r){
          return r.json().then(function(j){
            if (!r.ok) throw new Error(j.description || j.message || "Could not add to cart");
            if (j && j.sections) drawerState = j;
            return j;
          });
        });
      });
    }).then(function(){
      if (!EDIT) return null;
      /* Re-editing removes the old line after the new one is in, so the drawer
         has to be re-rendered off this call instead -- the copy from the add
         still shows the line that is about to go. */
      return fetch(CHANGE_URL, {
        method:"POST", credentials:"same-origin",
        headers:{ "Content-Type":"application/json", "Accept":"application/json" },
        body: JSON.stringify({ id: EDIT.key, quantity: 0,
                               sections: DRAWER_SECTIONS,
                               sections_url: window.location.pathname })
      }).then(function(r){ return r.json(); })
        .then(function(j){ if (j && j.sections) drawerState = j; return null; })
        .catch(function(){ return null; });
    }).then(function(){
      /* The bag is a drawer now. Landing on the cart page instead threw the
         customer out of the builder for no reason. */
      var opened = openCartDrawer(drawerState);
      if (opened){
        submitting = false;
        ROOT.classList.remove("cs-busy");
        return;
      }
      window.location.href = CFG.routes.cart;
    }).catch(function(err){
      submitting = false;
      ROOT.classList.remove("cs-busy");
      cartError((err && err.message) ? err.message : String(err));
    });
}
/* Hand the drawer the markup the theme rendered alongside the cart change and
   let it open itself. Anything missing -- an older theme, a page with no
   drawer -- falls back to the cart page, so the sale is never lost to this. */
var DRAWER_SECTIONS = "cart-drawer,cart-icon-bubble";
function openCartDrawer(state){
  var host = document.querySelector("cart-drawer");
  if (!host || typeof host.renderContents !== "function") return false;
  if (!state || !state.sections || !state.sections["cart-drawer"]) return false;
  try {
    host.classList.remove("is-empty");
    host.renderContents(state);
    return true;
  } catch(e){ return false; }
}

function cartError(msg){
  var m = $("#cartPayload");
  if (m) m.textContent = "Could not add to cart\n\n" + msg;
  $("#cartModal").classList.add("open");
}
Array.prototype.forEach.call($$("[data-close]"), function(b){ b.onclick = function(){ b.closest(".modal").classList.remove("open"); }; });
Array.prototype.forEach.call($$(".modal"), function(m){ m.addEventListener("click", function(e){ if (e.target === m) m.classList.remove("open"); }); });

$("#fileInput").onchange = function(e){ handleFiles(e.target.files); e.target.value = ""; };
$("#cartBtn").onclick = showCart;
$("#cartBtn2").onclick = showCart;
var resizeT;
window.addEventListener("resize", function(){ clearTimeout(resizeT); resizeT = setTimeout(function(){ layout(); render(); }, 90); });

buildModelPicker();
buildBg();
buildTabs();
buildCasePicker();
preload()
  .then(function(){ return EDIT_KEY ? restoreFromCart() : null; })
  .then(function(){ buildCasePicker(); ready = true; fullRefresh(); });

})();
